import { defineComponent } from "bitecs";

export const Cube = defineComponent({})
export const Object3DComponent = defineComponent({})
export const RPMAvatar = defineComponent({})